import { isEqual } from 'lodash'

class Flodash {
  static retrieveTripType(slices, origKey, destKey, airports) {
    let tripType = false

    if (slices instanceof Array && slices.length) {
      switch (slices.length) {
        case 1:
          tripType = 'OW'
          break
        case 2:
          tripType = 'RT'
          break
        default:
          tripType = 'MD'
      }
    }

    if (origKey && destKey && tripType === 'RT' && Flodash.isTwoSliceMD(slices, origKey, destKey, airports)) {
      tripType = 'MD'
    }

    return tripType
  }

  static isTwoSliceMD(slices, origKey, destKey, airports) {
    let isTwoSliceMD = false

    if (slices instanceof Array && origKey && destKey && slices.length === 2) {
      isTwoSliceMD = slices[0][origKey] !== slices[1][destKey] || slices[1][origKey] !== slices[0][destKey]
    }

    if (slices && (slices[0][origKey] instanceof Array || slices[0][destKey] instanceof Array)) {
      isTwoSliceMD =
        !isEqual(slices[0][origKey], slices[1][destKey]) || !isEqual(slices[1][origKey], slices[0][destKey])
    }

    if (
      airports &&
      slices.length === 2 &&
      (airports[slices[1]?.[origKey]]?.cityCode === airports[slices[0]?.[destKey]]?.cityCode &&
        airports[slices[0]?.[origKey]]?.cityCode === airports[slices[1]?.[destKey]]?.cityCode)
    ) {
      isTwoSliceMD = false
    }

    return isTwoSliceMD
  }

  static urlCreator(input) {
    if (!input) {
      console.error('must pass an object to function')
      return undefined
    }

    const validationList = [validateOrigAndDest, validatePassengerNumber]

    if (!validateObjectTypes(validationList)) {
      return undefined
    }

    const P1_MWEB_FLIGHTS = '/smartphone/air/airapp.do'
    const DESKTOP_FLY = '/fly/#/search/'
    const MOBILE_FLY = '/m/fly/search/'
    const FLY_DEALS = '/fly/deals/express/'

    if (input.mListings) {
      let pathUrlString = objectToUrlString(input, MOBILE_FLY, false)
      pathUrlString = objectToQueryParams(input.params, pathUrlString)
      return pathUrlString
    }

    if (input.asUrl) {
      return objectToUrlString(input, DESKTOP_FLY)
    }

    if (input.dealsUrl) {
      const origUrl = input.newDealsUrl ? MOBILE_FLY : FLY_DEALS
      let pathUrlString = objectToUrlString(input, origUrl, false)
      pathUrlString = objectToQueryParams(input.params, pathUrlString)
      return pathUrlString
    }

    const paramUrlString = objectToQueryParams(input, P1_MWEB_FLIGHTS)
    return paramUrlString

    // Pass in an argument of array of functions to validate
    function validateObjectTypes(validationList) {
      let validateBool = false

      validationList.forEach((func) => {
        if (func()) {
          validateBool = true
        }
      })

      if (validateBool) {
        return undefined
      }

      return true
    }

    // Checks if `loc` is a 3 letter alphabetical string
    function validateDestination(loc) {
      if (!loc) {
        return false
      }

      return /^[a-zA-Z]{3}$/.test(loc)
    }

    function validateOrigAndDest() {
      const slices = input.slices

      slices.forEach((slice) => {
        if (!validateDestination(slice.origAirport) || !validateDestination(slice.destAirport)) {
          console.error(
            'the object passed must have a string on both orig and dest ' +
              'and must contain the 3 letter airport code'
          )
          console.error(input)
          return true
        }
      })

      return undefined
    }

    function validatePassengerNumber() {
      if (input.totalPassengers && isNaN(input.totalPassengers)) {
        console.error('the object passed must have a a number on totalPassengers')
        console.error(input)
        return true
      }
    }

    function objectToQueryParams(obj, origUrl) {
      // Check for the asUrl Param
      const paramObj = {}
      for (const item in obj) {
        if (item === 'asUrl') {
          return undefined
        }
        paramObj[item] = obj[item]
      }

      const queryParams = buildQueryString(paramObj)

      const slashAtEnd = origUrl[origUrl.length - 1] !== '/' ? '/' : ''

      if (origUrl) {
        return `${origUrl}${slashAtEnd}?${queryParams}`
      }

      return queryParams

      // Builds a query string that is automatically endcoded
      // @param data which is an object
      function buildQueryString(data) {
        return Object.keys(data)
          .map((key) => {
            return [key, data[key]].map(encodeURIComponent).join('=')
          })
          .join('&')
      }
    }

    function objectToUrlString(obj, origUrl, passPassenger = true) {
      const slices = obj.slices

      // Takes a slice object and transforms it into a string
      // Ex. YVR-NYC-20161224
      const sliceStrings = slices.map((slice) => {
        const formattedDate = updateDateString(slice.departDate)
        const origAirport = slice.origAirport.toUpperCase()
        const destAirport = slice.destAirport.toUpperCase()
        return `${origAirport}-${destAirport}-${formattedDate}`
      })

      const concatenatedSlices = sliceStrings.join('/')
      const passengers = passPassenger ? '/' + obj.totalPassengers : ''
      let urlString = `${origUrl}${concatenatedSlices}${passengers}`

      // AIR_HOME_PAGE_TO_DEALS
      if (input.newDealsUrl) {
        urlString = `${origUrl}${concatenatedSlices}/deals`
      }

      return encodeURI(urlString)

      // From: 12/24/2016
      // To: 20161224
      function updateDateString(date) {
        const rearrangeDate = date.split('/')
        rearrangeDate.unshift(rearrangeDate.pop())
        return rearrangeDate.join('')
      }
    }
  }
}

const retrieveTripType = Flodash.retrieveTripType
const isTwoSliceMD = Flodash.isTwoSliceMD
const urlCreator = Flodash.urlCreator

export default Flodash
export { retrieveTripType, isTwoSliceMD, urlCreator }
